import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { TableCell } from 'components/shared/widget'
import { PcrTestRun } from 'entities/pcr_test_run'
import { ReactNode, useMemo } from 'react'
import { Form } from 'utils/hooks'
import { toDateText } from 'utils/util'

export const pcrTestRunColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, align: 'center', width: 60, form: form, orderAttr: 'pcr_test_run_id', searchType: { name: 'id', type: 'multiple_text' } },
            {
                name: 'Date',
                th: true,
                align: 'center',
                width: 100,
                form: form,
                orderAttr: 'pcr_test_run_created_at',
                searchType: { name: 'created_at', type: 'date' },
            },
            { name: 'Raw data', th: true, minWidth: 100, form: form },
        ],
    }
}

export type PcrTestRunTableDataProps = {
    pcrTestRun?: PcrTestRun
    displaySetting: DisplaySetting
}

export const PcrTestRunTableData = ({ pcrTestRun, displaySetting }: PcrTestRunTableDataProps): JSX.Element => {
    if (!pcrTestRun) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell align="center">{pcrTestRun.id}</TableCell>
                <TableCell align="center">{toDateText(pcrTestRun.createdAt)}</TableCell>
                <TableCell>
                    {pcrTestRun.rawData && (
                        <a href={pcrTestRun.rawData} target="_blank" rel="noreferrer">
                            {pcrTestRun.rawData.split('/').find((r) => r.includes('.xls'))}
                        </a>
                    )}
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
